export function initMobileMenu() {
    const header = document.querySelector('header');
    if (!header) return;

    const triggers = document.querySelectorAll('.navbar-toggler, .closepanel');

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            header.classList.toggle('active');
        });
    });
}
